<div class="main-heading">
  <a *ngIf="section" [routerLink]="[section.route]" class="main-heading__title">
    <span *ngIf="section.icon" [ngClass]="section.icon"></span>
    <span>{{ section.label | translate }}</span>
  </a>
  <ul *ngIf="items && items.length" class="breadcrumb-platform">
    <li *ngFor="let item of items; let i = index; let last = last" class="breadcrumb-platform__item">
      <span *ngIf="i > 0" class="glicon-doble-chevron"></span>
      <a
        *ngIf="item.route && !last"
        [routerLink]="[item.route]"
        fragment="{{ item.fragment ? item.fragment : null }}"
        >{{ item.label | translate }}</a
      >
      <!--Last level not current navigation-->
      <span *ngIf="!item.route || last" class="last-level">{{ item.label | translate }}</span>
    </li>
  </ul>
</div>
<lms-preloader></lms-preloader>
